import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 59 37"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M29.227 9.908c-3.937 0-7.774 2.736-7.774 8.04 0 5.973 4.137 8.909 8.208 8.909 4.07 0 7.706-2.703 7.706-7.974 0-6.039-4.137-8.975-8.14-8.975m1.167 14.78c-2.268 0-4.003-5.238-4.003-8.774 0-1.801.367-3.87 2.068-3.87 2.335 0 4.004 5.572 4.004 8.908 0 1.669-.3 3.737-2.069 3.737M15.98.067c.668 1.668 1.002 3.303 1.002 5.004v13.102L3.67 0H0v.067C.667 1.735 1 3.37 1 5.07v16.55c0 1.701-.333 3.336-1 5.004v.067h4.67v-.067c-.666-1.668-1-3.303-1-5.004V8.613L16.982 26.69h2.669V5.071c0-1.701.234-3.336.9-5.004V0h-4.57zm24.69 21.32c-1.234 0-2.469.867-2.469 2.569 0 1.968 1.368 2.936 2.67 2.936 1.2 0 2.435-.9 2.435-2.57 0-2-1.368-2.935-2.636-2.935M51.713 0v.067c.667 1.668 1 3.303 1 5.004v21.62c0 4.538-1.4 9.475-6.772 9.475l.033.834c7.107 0 11.71-4.37 11.71-10.31V5.071c0-1.701.234-3.336.901-5.004V0z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "TheNoJ"}) } }